import type { RouteObject } from 'react-router-dom';
import { lazyElement } from '../routing/lazyRoute';

const cdrRoutes: RouteObject[] = [
  {
    path: '/cdr',
    element: lazyElement(() => import('./List')),
    handle: {
      documentTitle: 'CDRs',
      crumb: () => ({ label: 'CDRs', to: '/cdr' }),
    },
  },
];

export default cdrRoutes;
